import { z } from 'zod';
/** Compare demo-data slice — the CMP_ACCOUNTS roster the Compare Accounts screen ranks side by side
 *  (design-reference script lines 1450–1454). fill = chart/bar tone, ink = the text-safe counterpart.
 *  Every field is deterministic and labeled simulated; the per-account metrics are derived from `trades()` at build time. */
export const CmpAccountSchema = z
  .object({
    id: z.string(), // matches the account column of the trade ledger
    nickname: z.string(),
    broker: z.string(),
    type: z.string(), // Live / Challenge / Funded
    balance: z.number(),
    colour: z.string(), // chart/bar fill token
    ink: z.string(), // text-safe counterpart token
  })
  .strict();
export const CompareDataSchema = z
  .object({
    accounts: z.array(CmpAccountSchema),
  })
  .strict();
export type CompareData = z.infer<typeof CompareDataSchema>;
export type CmpAccount = z.infer<typeof CmpAccountSchema>;
